import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCe-yzrZ1VqLdbhwUVD-TKT-x1cyJPWi8w",
    authDomain: "lamar-f7165.firebaseapp.com",
    projectId: "lamar-f7165",
    storageBucket: "lamar-f7165.firebasestorage.app",
    messagingSenderId: "514154499785",
    appId: "1:514154499785:web:ef72d758a3c52303eb0718",
    measurementId: "G-LMKYBKZ9XV"
};

// تهيئة Firebase
const app = initializeApp(firebaseConfig);

// الخدمات المستخدمة
export const auth = getAuth(app);
export const db = getFirestore(app);
export const realtimeDB = getDatabase(app);
export const storage = getStorage(app);

export default app;